import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {
  selectActualHasLimitedPocView,
  selectPartner,
  selectSelfCompanyName,
  selectUserEmail,
} from 'containers/App/selectors'

import Navigation from 'components/pages/navigation'

import { selectIncidentsCount } from '../Polling/selectors'

import {
  selectAccountSetupVisibility,
  selectAwarenessVisibility,
  selectDmarcVisibility,
  selectGroupSettingsVisibility,
  selectIncidentsVisibility,
  selectInvestigationVisibility,
  selectMailboxesVisibility,
  selectUserDropdownItems,
} from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)
const mapStateToProps = (state) => ({
  partner: selectPartner(state),
  companyName: selectSelfCompanyName(state),
  userEmail: selectUserEmail(state),
  incidentsCount: selectIncidentsCount(state),
  userDropdownItems: selectUserDropdownItems(state),
  hasLimitedPocView: selectActualHasLimitedPocView(state),

  incidentsVisibility: selectIncidentsVisibility(state),
  investigationVisibility: selectInvestigationVisibility(state),
  awarenessVisibility: selectAwarenessVisibility(state),
  mailboxesVisibility: selectMailboxesVisibility(state),
  groupSettingsVisibility: selectGroupSettingsVisibility(state),
  accountSetupVisibility: selectAccountSetupVisibility(state),
  dmarcVisibility: selectDmarcVisibility(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(Navigation)

export default withRouter(render)
